import { Mui } from "@osu/react-ui";
import { Fragment } from "react";
const { TextField, Autocomplete, CircularProgress } = Mui;

export default function AsyncDropdown(props = {}) {
  const { label, loading,id, name,slotProps, filterOptions, error, helperText, required, ...rest } = props
  return (
    <Autocomplete
      loading={loading}
      id={id}
      filterOptions={filterOptions}
      renderInput={({ ...params}) => {
       return <TextField
          {...params}
          label={label}
          name={name}
          helperText={helperText}
          error={error}
          required={required}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
            },
          }}
        />
      }}
      slotProps={slotProps}
      {...rest}
    />
  );
}
